import { useEffect, useRef, useState } from "react";
import { EmployeeApi } from "src/api";
import GoodErrorMessage from "src/components/Modal/GoodErrorMessage";
import { useChat } from "src/contexts/chat.context";
import { ChatOption } from "src/modules/ai-agent/enums";
import { ExpiredSessionError, dictionary, i18n } from "src/utils";
import RegistrationForm from "./RegistrationForm";

function RegistrationFormContainer(): JSX.Element {
  const { setOption } = useChat();
  const [employeeList, setEmployeeList] = useState<Employee[]>([]);

  async function getEmployeeData(): Promise<boolean> {
    return await EmployeeApi.fetch()
      .then((res: Employee[]) => {
        setEmployeeList(res);
        return true;
      })
      .catch((error) => {
        if (!(error instanceof ExpiredSessionError)) {
          GoodErrorMessage({
            title: i18n(dictionary.error.GET_EMPLOYEE_ERROR.title),
            message: i18n(dictionary.error.GET_EMPLOYEE_ERROR.message),
            onClickLink: () => setOption(ChatOption.CHAT),
            onOk: () => {
              dataFetchedRef.current = false;
              getInitData();
            },
          });
        }
        throw error;
      });
  }

  const dataFetchedRef = useRef(false);
  async function getInitData() {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    try {
      await getEmployeeData();
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getInitData();
  }, []);

  return <RegistrationForm employees={employeeList} />;
}

export default RegistrationFormContainer;
